import React from "react";
import { cn } from "./cn";
import { CloseIcon } from "../../../assets/ui/icons";

/* A selected value shown as a removable pill — the industry classifications picked on step 3. */
export const TagChip = ({ children, onRemove, className = "", ...rest }) => (
  <span
    className={cn(
      "inline-flex items-center gap-1.5 rounded-full bg-[var(--orange-soft)]",
      "py-1.5 pl-3 pr-2.5 text-[12.5px] font-semibold text-[var(--orange)] font-sans",
      className
    )}
    {...rest}
  >
    {children}
    {onRemove && (
      <button
        type="button"
        onClick={onRemove}
        aria-label={`Remove ${typeof children === "string" ? children : "item"}`}
        /* A solid token, not an opacity modifier: Tailwind cannot inject an
           alpha channel into a var() colour (see F-006). */
        className="flex rounded-full p-0.5 text-[var(--orange)] hover:bg-[var(--orange-border)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--orange)]"
      >
        <CloseIcon size={12} />
      </button>
    )}
  </span>
);

export default TagChip;
